"use strict";

exports.__esModule = true;
exports.MTCDataTableFields = void 0;
exports.MTCDataTableFieldsClosure = MTCDataTableFieldsClosure;
var _react = _interopRequireDefault(require("react"));
var _core = require("@blueprintjs/core");
var _Core = require("../../Core");
var _DataTable = require("../../Core/DataTable");
var _Device = require("../../Device");
var _Fields = require("../AdvancedDataTable/Fields");
var _DataItemChartSelectorAdaptor = require("../DataItemChart/DataItemChartSelectorAdaptor");
var _Fields2 = require("../DataTable/Fields");
var _DataTableColumn = require("../DataTableColumn");
var _DataSources = require("../DataTable/DataSources");
var _DataTable2 = require("../DataTable");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function MTCDataTableFieldsClosure(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
    _ref$dataSource = _ref.dataSource,
    dataSource = _ref$dataSource === void 0 ? "MTC" : _ref$dataSource;
  /**
   * Fields for DataTableElement.
   */
  return function MTCDataTableFields(props) {
    var path = props.path,
      elementEditor = props.elementEditor,
      element = props.element;
    var _element$props$pageSi = element.props.pageSizes,
      pageSizes = _element$props$pageSi === void 0 ? [25, 50, 100, 250] : _element$props$pageSi;
    var devices = _react["default"].useContext(_Device.DeviceListContext);
    var _React$useContext = _react["default"].useContext(_Core.TranslatorContext),
      translate = _React$useContext.translate;
    var mtcTableDefinition = _DataSources.DataSourceDefinitions[dataSource](translate);
    var configuration = element.props.configuration;
    if (!configuration && mtcTableDefinition) {
      configuration = (0, _DataTable2.boostrapDefaultColumns)(configuration, elementEditor, mtcTableDefinition, path);
    }
    return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_core.FormGroup, {
      label: translate("DataItem.dataItem.label", "Data Item"),
      helperText: translate("DataItem.dataItem.helperText", "Note: This widget will appear blank for devices without corresponding data items.")
    }, /*#__PURE__*/_react["default"].createElement(_DataItemChartSelectorAdaptor.DataItemChartSelectorAdaptor, {
      value: typeof element.props.dataItemName == "string" ? [{
        dataItemName: element.props.dataItemName
      }] : element.props.dataItemName,
      onChange: function onChange(value) {
        elementEditor.setProp(path, "dataItemName", value);
      },
      devices: devices,
      multiple: true
    })), /*#__PURE__*/_react["default"].createElement(_Fields2.AddColumnField, {
      dataSourceDefinition: mtcTableDefinition,
      onAddColumn: function onAddColumn(column) {
        elementEditor.appendElementAt(path, _DataTableColumn.DataTableColumnWidget.createElement(Object.assign({}, column)));
      }
    }), /*#__PURE__*/_react["default"].createElement(_Fields.AdvancedDataRangeSelector, {
      setProp: function setProp(value) {
        elementEditor.setProp(path, "dataRange", value);
      },
      value: element.props.dataRange || "",
      fetchDataOnlyOnSelection: element.props.fetchDataOnlyOnSelection,
      setFetchOnlyOnSelection: function setFetchOnlyOnSelection(value) {
        elementEditor.setProp(path, "fetchDataOnlyOnSelection", value);
      }
    }), /*#__PURE__*/_react["default"].createElement(_DataTable.DefaultPageSize, {
      setDefaultPageSize: function setDefaultPageSize(value) {
        elementEditor.setProp(path, "configuration", Object.assign({}, configuration, {
          defaultPageSize: value
        }));
      },
      pageSizes: pageSizes,
      defaultPageSize: configuration.defaultPageSize
    }));
  };
}
var MTCDataTableFields = exports.MTCDataTableFields = MTCDataTableFieldsClosure();